import React from 'react'
import { inject, observer } from 'mobx-react'

const Languages = ({ staticData, languages }) => {
  if (!languages || !languages.length) {
    return <div>No languages added!</div>
  }

  const langs = languages.map(language => {
    const name = staticData.names.languages[language.languageId]
    const proficiency =
      staticData.names.languageProficiencies[language.languageProficiencyId]

    return (
      <li className='language' key={language.id}>
        <span className='language__name'>{name}</span>
        <span className='language__proficiency'>{proficiency}</span>
      </li>
    )
  })

  return <ul className='language__list'>{langs}</ul>
}

export default inject('staticData')(observer(Languages))
